import { AppstoreAddOutlined } from '@ant-design/icons';

import { SCard } from 'app/components/StaycationUI';
import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';

import { CustomReactMarkdown } from '../CustomMarkdown/CustomMarkdown';

import './MarkdownPreview.scss';

type MarkdownPreviewProps = {
  values: {
    description?: string | null;
    menu?: string | null;
    treatmentList?: string | null;
    importantInformation?: string | null;
  };
};

export const MarkdownPreview = ({ values }: MarkdownPreviewProps) => {
  if (!values) {
    return (
      <SCard title={'Content preview'} className="markdown-preview-card">
        <EmptyState
          title="No description"
          description="Enter a description to see the formatted preview here using markdown."
          icon={<AppstoreAddOutlined className="empty-state" />}
        />
      </SCard>
    );
  }

  const { description, menu, treatmentList, importantInformation } = values;

  return (
    <SCard title={'Content preview'} className="markdown-preview-card">
      {description || menu || treatmentList || importantInformation ? (
        <div className="view-text__area">
          {description && description.trim() && (
            <>
              <h4>Description</h4>
              <CustomReactMarkdown>{description}</CustomReactMarkdown>
              <hr />
            </>
          )}
          {menu && menu.trim() && (
            <>
              <h4>Menu</h4>
              <CustomReactMarkdown>{menu}</CustomReactMarkdown>
              <hr />
            </>
          )}
          {treatmentList && treatmentList.trim() && (
            <>
              <h4>Treatment list</h4>
              <CustomReactMarkdown>{treatmentList}</CustomReactMarkdown>
              <hr />
            </>
          )}
          {importantInformation && importantInformation.trim() && (
            <>
              <h4>Important information</h4>
              <CustomReactMarkdown>{importantInformation}</CustomReactMarkdown>
            </>
          )}
        </div>
      ) : (
        <EmptyState
          title="No description"
          description="Enter a description to see the formatted preview here using markdown."
          icon={<AppstoreAddOutlined className="empty-state" />}
        />
      )}
    </SCard>
  );
};
